module.exports = __webpack_public_path__ + "img/icon_sm_skcb.15f4193c.png";